const url = '/component-types';
const Provider = 'ComponentTypes';
const dbModel = 'ComponentTypes';

export { url, Provider, dbModel };
